import {
  Services as graphServices,
  Service as graphService,
} from "@/generated/graphql";

export class Services {
  dxf: Service = new Service();
  invoice: Service = new Service();
  bfm: Service = new Service();
  loan: Service = new Service();

  constructor();
  constructor(services: graphServices);
  constructor(services?: graphServices) {
    if (services) {
      this.dxf = new Service(services.dxf);
      this.invoice = new Service(services.invoice);
      this.bfm = new Service(services.bfm);
      this.loan = new Service(services.loan);
    }
  }
}

class Service {
  redirectURL: string = "";
  using: boolean = false;

  constructor();
  constructor(service: graphService);
  constructor(service?: graphService) {
    if (service) {
      this.redirectURL = service.redirectURL;
      this.using = service.using;
    }
  }

  isEnabled(): boolean {
    return this.redirectURL != "";
  }
}
